import axios from 'axios';
import store from '@/store';
import token from '@/data/user/token';
axios.interceptors.request.use(
  /**
   * @author Alejandro
   * @description This interceptor checks user's time to live session before each request to the server.
   * @param {AxiosRequestConfig} config
   * @returns {Promise<AxiosRequestConfig>}
   */
  async config => {
    // gs20 behavior
    if (store.state.loginGeneral.booleanIsGSBehavior) {
      if (
        window.location.pathname !== '/login' &&
        !store.getters['loginGeneral/isUserSessionLive'] &&
        !window.localStorage.getItem('user')
      ) {
        store.commit('mediaGeneral/setUserPlaylists', []);
        store.commit('teamsGeneral/updateTeams', []);
        store.commit('loginGeneral/setSeasonsSelected', null);
        if (window.localStorage.getItem('isFromApp')) {
          await store.dispatch('loginGeneral/deleteUserInfo');
          window.location.replace(`${window.location.origin}/login?app=1`);
        } else {
          await store.dispatch('loginGeneral/deleteUserInfo');
          window.location.replace(`  ${process.env.VUE_APP_B2C_URL}/gs-logout`);
        }
        throw new axios.Cancel("User's session time has ended.");
      }
      if (config.url.includes('.json')) {
        config.headers['Authorization'] = '';
      }
      if (config.url.includes('pushInternalData')) {
        config.headers['Authorization'] = '';
      } else if (
        window.location.pathname.includes('/playerprofile') ||
        window.location.pathname.includes('/teamsAnalysis') ||
        window.location.pathname.includes('/login')
      ) {
        if (
          config.url.includes('qyyibs1w0d.execute-api.us-west-2') ||
          config.url.includes('ts7thxzaik.execute-api.us-west-2')
        ) {
          // const user = store.getters['loginGeneral/getUser'];
          // config.headers['Authorization'] = user.token_b2c || '';
        }
        //token
      } else {
        // const user = store.getters['loginGeneral/getUser'];
        // config.headers['Authorization'] = user.token_b2c || '';
      }

      await store.dispatch('loginGeneral/updateUserSessionExpiration');
      if (config.url.includes('.pdf')) {
        delete config.headers['Authorization'];
      }
    } else {
      if (config.url.includes('.json') || config.url.includes('.mp4')) {
        config.headers['Authorization'] = '';
        // delete config.headers['Authorization'];
      } else {
        if (config.url.includes('pushInternalData')) {
          config.headers['Authorization'] = '';
        } else if (
          window.location.pathname.includes('/playerprofile') ||
          window.location.pathname.includes('/teamsAnalysis') ||
          window.location.pathname.includes('/login')
        ) {
          if (
            config.url.includes('qyyibs1w0d.execute-api.us-west-2') ||
            config.url.includes('ts7thxzaik.execute-api.us-west-2')
          ) {
            // config.headers['Authorization'] = '';
          }
          //token
        } else {
          if (window.localStorage.getItem('user')) {
            let user = window.localStorage.getItem('user');
            user = JSON.parse(window.atob(user));
            config.headers['Authorization'] = user.token_b2c || '';
          } else {
            config.headers['Authorization'] =
              'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MCwibmFtZ' +
                'SI6IlVzdWFyaW8gRnJlZSIsInVzZXJuYW1lIjoiZnJlZUBnb2xzdGF0' +
                'cy5jb20iLCJlbWFpbCI6ImZyZWVAZ29sc3RhdHMuY29tIiwiaWF0IjoxN' +
                'jA2NzU4Nzk1LCJleHAiOjE2MzgyOTQ3OTV9.kPNmP7yDtk38cAXr' +
                'Uyc7OHRh6J25VFqy-XUNzbK-4YE' || '';
          }
        }

        await store.dispatch('loginGeneral/updateUserSessionExpiration');
        if (config.url.includes('.pdf')) {
          delete config.headers['Authorization'];
        }
      }
    }
    return config;
  },
  e => {
    return Promise.reject(e);
  },
);

axios.interceptors.response.use(
  response => response,
  e => {
    if (e.request && e.request.status && (e.request.status === 401 || e.request.status === 403)) {
      // store.dispatch('loginGeneral/doLogout', { reloadPage: true, requestStatus: e.request.status });
      store.commit('mediaGeneral/setUserPlaylists', []);
      store.commit('teamsGeneral/updateTeams', []);
      store.commit('loginGeneral/setSeasonsSelected', null);
      let user = {
        id: 32544,
        player: 0,
        show_dashboard: 0,
        token_b2c: token.free,
        tournament: 1,
        season: 1694,
        premiumAccount: false,
        userType: 0, //0, b2c - 1 gol
        accessVideos: false,
        active_time: 0, //0: no activo - 1: activo
        language: 'es',
      };
      window.localStorage.removeItem('user');
      store.commit('setSeasonsSelected', null);
      window.localStorage.removeItem('urlGS1');
      window.localStorage.removeItem('seasonSelected');
      window.localStorage.removeItem('tournamentSelected');
      window.localStorage.removeItem('isFromApp');
      window.localStorage.removeItem('data-search');
      store.commit('setPymErr', false);
      store.commit('profileGeneral/updateCards', [], { root: true });
      store.commit('profileGeneral/setCurrentPlanId', null, { root: true });
      store.commit('profileGeneral/setProfilePlans', [], { root: true });
      window.localStorage.setItem('user', window.btoa(JSON.stringify(user)));
      store.commit('setUser', user);
      setTimeout(() => {
        if (window.sessionStorage.getItem('IsWidget') === null) {
          window.location.replace('/bets');
        } else {
          window.location.replace('/widget/' + window.sessionStorage.getItem('WidgetTeam'));
        }
      }, 200);
    }
    return Promise.reject(e);
  },
);
